<template>
  <div class="containerMod">
    <div class="bloqueFicha"
      v-for="pub_per in pubs_perShow" :key="pub_per._id">
      <div class="editor">{{pub_per.editorial}}</div>
      <div class="restoDatos">
        <div class="datosPub">
          <div class="nombre">{{pub_per.nombre}}</div>
          <div class="line2">
            {{pub_per.ciudad}} - {{pub_per.pais}}
            {{pub_per.idioma ? (' | ' + pub_per.idioma) : `` }}
            {{pub_per.ISSN ? (' | ISSN ' + pub_per.ISSN) : `` }}
          </div>
          <!-- <div class="Linea2">{{LineaDatos}}</div> -->
        </div>
        <div class="selector" v-show="!aislar"
          @click="aislarPubPer(pub_per._id)">&dtrif;
        </div>
        <div class="selector" v-show="aislar"
          @click="retornoPubPer()">&ltrif;
        </div>
      </div>
    </div>
    <div class="containerEdiciones" v-if="aislar">
      <div v-if="loading" class="loading-container">
        <div class="loader"></div>
      </div>
      <div v-else>
        <div class="bloqueEdicion"
          v-for="( edi_per, index ) in edis_per" :key="index">
            <div>
              <img class="portada" :src="edi_per.imgPortada"/>
              <img class="portada" v-show="!(edi_per.imgPortada)" src='@/assets/PortadaND.png'/>
            </div>
            <div class="contenido">
              <div class="linea1">
                {{edi_per.volumen ? (' Volumen ' + edi_per.volumen) : `` }}
                {{edi_per.numero ? ('Número ' + edi_per.numero) : `` }}
                {{edi_per.mes ? (' | ' + mes(edi_per.mes)) : `` }} - {{edi_per.anyo}}
              </div>
              <div class="linea2">
                {{edi_per.numPaginas ? (edi_per.numPaginas + ' páginas') : `` }}
                {{edi_per.size ? (' | ' + edi_per.size + 'mm') : `` }}
              </div>
              <div class="linea3">
                {{edi_per.edicionP === '1' ? 'Edición papel' : (edi_per.edicionE === '1' ? 'Edición digital' : ``)}}
                {{edi_per.edicionP === '1' ? (edi_per.edicionE ? ' | ' + 'Versión digital' : ``) : `` }}
              </div>
              <div class="linea4">
                <div class="lineaIndice">
                  <p class="indice">Índice</p>
                  <p class="up" @click="verIndice(edi_per._id)" v-show="!indicesVisibles.some(e => e === edi_per._id)">&dtrif;</p>
                  <p class="down" v-show="indicesVisibles.some(e => e === edi_per._id)" @click="ocultarIndice(edi_per._id)">&utrif;</p>
                </div>
                <p v-show="indicesVisibles.some(e => e === edi_per._id)">{{edi_per.indice}}</p>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import XCerrarModal from './XCerrarModal.vue'
import axios from 'axios'
export default {
  // components: { XCerrarModal },
  name: 'ShowPubPer',
  created () {
    this.URLbase = process.env.VUE_APP_ROOT_API
    this.getPublicaciones()
  },
  emits: ['scrollHidden', 'NoScrollHidden'],
  data () {
    return {
      visible: false,
      pubs_per: [],
      edis_per: [],
      aislar: false,
      indicesVisibles: [],
      desplegado: false,
      loading: false,
      URLbase: '',
      meses:
        ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio',
          'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
    }
  },
  methods: {
    cerrarModal: function () {
      this.$router.go(-1)
    },
    async getPublicaciones () {
      try {
        const url = `${this.URLbase}/pubsPers/getPubsPers`
        const res = await fetch(url)
        this.pubs_per = await res.json()
      } catch (error) {
        alert(error)
      }
    },
    async getEdiciones (id) {
      try {
        this.loading = true
        const url = `${this.URLbase}/edisPers/getEdisPers`
        const PUBPER = { _id: id }
        const res = await axios.post(url, PUBPER)
        this.edis_per = res.data
        this.loading = false
      } catch (error) {
        alert(error)
        this.loading = false
      }
    },
    aislarPubPer (idPubPer) {
      this.aislar = true
      this.idPubPer = idPubPer
      this.$emit('scrollHidden')
      this.getEdiciones(idPubPer)
    },
    retornoPubPer () {
      this.aislar = false
      this.$emit('NoScrollHidden')
    },
    mes (numMes) {
      return this.meses[numMes - 1]
    },
    verIndice (ID) {
      this.indicesVisibles.push(ID)
      this.desplegado = !this.desplegado
    },
    ocultarIndice (ID) {
      this.indicesVisibles = this.indicesVisibles.filter(e => e !== ID)
      this.desplegado = !this.desplegado
    }
  },
  computed: {
    pubs_perShow () {
      return this.aislar ? this.pubs_per.filter(e => e._id === this.idPubPer) : this.pubs_per
    }
  }
}
</script>

<style scoped>
*{
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.containerMod {
  overflow-y: auto;
  height: 99.9%;
  width: 100%;
  background-color: var(--gr-fo-for);
  margin-top: 2px;
}
.bloqueFicha{
  display: flex;
  /* flex-direction: column; */
  width:100%;
  /* margin-top: 2px; */
  /* flex-wrap: wrap; */
  background-color: rgb(238, 228, 198);
  /* border: solid 0.5px rgb(255, 169, 30); */
}
.editor{
  background-color: rgb(0, 68, 88);
  width: 35%;
  padding: 4px;
}
.restoDatos{
  display:flex;
  justify-content:center;
  /* align-items:stretch; */
  border-bottom: solid 0.5px rgb(0, 68, 88);
  width: 65%;
}
.datosPub{
  width:90%;
}
/* .selector{
  width: 10%;
  font-size: 30px;
} */
.nombre{
  font-family: SegoeBI;
  color: rgb(1, 56, 82);
  padding-left: 10px;
  padding-top: 4px;
  text-align: left;
}
.line2{
  padding-left: 10px;
  padding-bottom: 10px;
  color: rgb(1, 56, 82);
  font-size: 14px;
  text-align: left;
}
.containerEdiciones{
  height: 88%;
  margin-top: 5px;
  overflow-y: auto;
  background-color: rgba(251, 246, 234, 0.8);
  color:rgb(100, 143, 163);
}
.bloqueEdicion{
  margin-top: 10px;
  padding-bottom: 1px;
  display: grid;
  grid-template-columns: 26% 70%;
  /* border: solid 1px rgb(255, 169, 30); */
}
.portada{
  width: 130px;
  box-shadow: rgb(87, 85, 85) 5px 5px 7px;
  /* border: solid 1px rgb(255, 169, 30); */
}
.portadaND{
  width: 120px;
  height: 170px;
  border: solid 0.5px rgb(63, 193, 253);
  border-radius: 5px;
  /* border: solid 1px rgb(255, 169, 30); */
}
.contenido{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 10px;
  border-bottom: solid 0.5px rgb(136, 166, 180);
  padding-bottom: 25px;
  margin-bottom: 0px;
}
.linea1{
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: 17px;
  color: rgb(1, 56, 82);
}
.linea2, .linea3{
  font-size: 14px;
}
.linea4{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  white-space: pre-line;
  color:rgb(1, 56, 82)
}
.linea4 p{
  text-align: left;
}
.lineaIndice{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.indice{
  font-weight: bold;
  color: rgb(32, 164, 204);
  font-size: 16px;
}
.up, .down{
  cursor:pointer;
  font-size: 30px;
}
.selector, .retorno{
  color: rgb(0, 137, 200);
  font-size: 25px;
  font-weight: bolder;
  cursor: pointer;
  height: 16px;
  width: 16px;
  align-self: center;
  padding-bottom: 8px;
}
.loading-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.loader {
  border: 4px solid transparent;
  border-top-color: #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
  margin: auto;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
@media screen and (max-width: 576px){
 .containerMod{
  display: flex;
  flex-direction: column;
  align-items: center;
 }
 .bloqueFicha{
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%
  }
  .editor{
    width:100%;
  }
  .restoDatos{
    width: 100%;
    border-bottom: none;
  }
  .linea1, .linea2, .linea3, .linea4{
    text-align: left;
    padding-left: 15px;
    padding-right: 15px;
  }
  .linea2{
    margin-top: 2px;;
}
  .containerEdiciones{
    width: 100%;
  }
  .bloqueEdicion{
    display: flex;
    flex-direction: column;
  }
  .portada{
    width: 200px;
    margin-top: 5px;
    margin-bottom: 15px;
  }
  .portadaND{
    width: 160px;
    margin-top: 5px;
    margin-bottom: 15px;
  }
  .up, .down{
    margin:  2px 4px 0;
  }
}
</style>
